import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import Config from '../../config';
import { useAuthenticationStore } from '../../stores/authenticationStore';

/**
 * Redirects to an external cyber-range destination with a freshly-minted SSO token
 * so the user arrives logged in. Attach as a beforeEnter guard on a trampoline route
 * whose meta declares:
 *   - ssoTargetKey: a Config key naming the destination base URL (read at navigation
 *                   time so env.json overrides apply).
 *
 * Whether the destination opens in a new tab is decided at the call site (target="_blank"
 * on the router-link), not here.
 */
export default async function ssoRedirect(to: RouteLocationNormalized,
                                          from: RouteLocationNormalized,
                                          next: NavigationGuardNext,
                                          authenticationStore = useAuthenticationStore()
)                                       : Promise<void>
{
    const targetKey = to.meta.ssoTargetKey as keyof typeof Config;

    const url = new URL(Config[targetKey] as string);
    url.searchParams.set('s', await authenticationStore.getSsoToken());

    window.location.href = url.href;
}
